import React, {useState, useEffect} from 'react';
import {Context} from '../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import i18n from '../../i18n';
import {useTranslation} from 'react-i18next';
import Tabela from '../../components/Agendamentos/Agenda';
import TableChartIcon from '@mui/icons-material/TableChart';
import Calendario from '../../components/Agendamentos/Calendario';
import Table from '../../components/Propostas/Table';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DrawerFilter from '../../components/Propostas/DrawerFilter';
import NovaProposta from '../../components/Propostas/NovaProposta';
import {useContext} from 'react';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import {verifAuthenticated} from '../../Services/API';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import {getEstadosProposta, getRepresentantes, getTiposPropostas} from '../../pages/requests';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';

function Propostas(color) {
    const {t} = useTranslation();

    // Apresenta form de proposta ou não
    const [showForm, setShowForm] = useState(false);

    // Indica se o form está em modo de edição ou não
    const [editarProposta, setEditarProposta] = useState(false);

    // Separador do form que está visivel
    const [openTab, setOpenTab] = React.useState(1);

    // flag para guardar proposta
    const [guardar, setGuardar] = useState(false);

    // flag para guardar proposta
    const [gerarRevisaoProposta, setGerarRevisaoProposta] = useState(false);
    // flag para enviar proposta email
    const [enviarEmailProposta, setEnviarEmailProposta] = useState(false);
    // flag para imprimir
    const [imprimirProposta, setImprimirProposta] = useState(false);

    // flag com indicação de se foram efetuados alterações no prospect
    const [onChangeForm, setOnChangeForm] = useState(false);

    // Proposta que está selecionada
    const [propostaSelecionada, setPropostaSelecionada] = useState(null);

    const {path, setPath} = useContext(Context);

    const [idNegocio, setIdNegocio] = useState('');

    const history = useHistory();

    const [filtroCodigo, setFiltroCodigo] = useState('');
    const [filtroDescNegocio, setFiltroDesNegocio] = useState('');
    const [filtroTipo, setFiltroTipo] = useState(null);
    const [filtroDt, setFiltroDt] = useState({startDate: null, endDate: null});
    const [filtroCliente, setFiltroCliente] = useState('');
    const [filtroEstado, setFiltroEstado] = useState(null);
    const [filtroEncomenda, setFiltroEncomenda] = useState({value: 0, label: 'Não'});
    const [filtroRepresentantes, setFiltroRepresentantes] = useState([]);
    const [filtroLinhas, setFiltroLinhas] = useState('');

    // FILTROS
    const [tipos, setTipos] = useState([]);
    const [estados, setEstados] = useState([]);
    const [representantes, setRepresentantes] = useState([]);
    const [encomendas, setEncomendas] = useState([
        {value: 0, label: 'Não'},
        {value: 1, label: 'Sim'},
    ]);

    // FILTRO STATUS
    const [filtroDtStatus, setFiltroDtStatus] = useState({startDate: null, endDate: null});
    const [filtroUtilizador, setFiltroUtilizador] = useState('');
    const [filtroAcao, setFiltroAcao] = useState('');
    const [filtroDestinatarios, setFiltroDestinatarios] = useState('');
    const [filtroEmail, setFiltroEmail] = useState('');

    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') { 
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }
    const tabText = tab => {
        switch (tab) {
            case 1:
                return {
                    text: t('dadosBase'),
                    icon: <TextSnippetOutlinedIcon className="mr-2" />,
                };
            case 2:
                return {
                    text: t('geral'),
                    icon: <SummarizeOutlinedIcon className="mr-2" />,
                };
            case 3:
                return {
                    text: t('contapagamentoctos'),
                    icon: <RequestQuoteOutlinedIcon className="mr-2" />,
                };
            case 4:
                return {
                    text: t('garantia'),
                    icon: <EventAvailableOutlinedIcon className="mr-2" />,
                };
            case 5:
                return {
                    text: t('manutencao'),
                    icon: <BuildCircleOutlinedIcon className="mr-2" />,
                };
            case 6:
                return {
                    text: t('retoma'),
                    icon: <ChangeCircleOutlinedIcon className="mr-2" />,
                };
            case 7:
                return {
                    text: t('status'),
                    icon: <BarChartRoundedIcon className="mr-2" />,
                };

            default:
                return {
                    text: '',
                    icon: null,
                };
        }
    };
    const {text, icon} = tabText(openTab);
    const handleRowClick = dados => {
        setShowForm(true);
        setEditarProposta(false);
        setOpenTab(1);
        setOnChangeForm(false);
        setPropostaSelecionada(dados);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(async () => {
        //await verifAuthenticated();

        getTiposPropostas(lang).then(res => {
            setTipos(res.data.tiposOrcamento);
        });

        getEstadosProposta(lang).then(response => {
            setEstados(response.data.estados);
        });

        getRepresentantes(lang).then(res => {
            setRepresentantes(res.data.representantes);
        });
    }, []);

    useEffect(() => {
        if (propostaSelecionada != null && showForm) {
            setPath(t('editarProposta') + ' ' + propostaSelecionada.id + ' - ' + propostaSelecionada.cliente?.nomeCliente);
        } else if (showForm && propostaSelecionada == null) {
            setPath(t('novaProposta'));
        } else {
            setPath('');
        }
    }, [path, propostaSelecionada, showForm]);

    useEffect(() => {
        if (history.location.state?.negocio) {
            setShowForm(true);
            setEditarProposta(true);
            return;
        }

        if (history.location.state?.proposta) {
            handleRowClick(history.location.state?.proposta);
            return;
        }

        const searchName = history.location.search;
        setIdNegocio(searchName?.split('negocio=')[1]?.split('&')[0]);
        if (history.location?.search != '' && history.location?.search != null && searchName.split('agendamento=')[1] == undefined) {
            setShowForm(true);
        } else if (history.location?.search != '' && history.location?.search != null && searchName.split('agendamento=')[1] != undefined) {
            setShowForm(true);
            setEditarProposta(true);
            setPropostaSelecionada(history.location.state);
        }
    }, [history]);

    return (
        <>
            {isMobile && showForm ? (
                <div
                    className="flex flex-wrap-reverse mt-2 items-center justify-between -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
                    role="tablist"
                    id="myTab"
                    data-tabs-toggle="#myTabContent">
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        type="button">
                        {icon} {text}{' '}
                        <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                        </svg>
                    </button>

                    {isOpen && (
                        <div className="absolute z-10 w-60 mt-2 bg-white divide-y divide-gray-100 rounded-[8px] shadow  dark:bg-gray-700">
                            <ul className="py-2 text-sm text-gray-700 dark:text-gray-200 w-60">
                                <li>
                                    <a
                                        href="#"
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(1);
                                            setIsOpen(false);
                                        }}
                                        className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 1 ? 'bg-blue-500 text-white' : ''}`}>
                                        <TextSnippetOutlinedIcon className="mr-2" /> {t('dadosBase')}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="#"
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(2);
                                            setIsOpen(false);
                                        }}
                                        className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 2 ? 'bg-blue-500 text-white' : ''}`}>
                                        <SummarizeOutlinedIcon className="mr-2" />
                                        {t('geral')}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(3);
                                            setIsOpen(false);
                                        }}
                                        href="#"
                                        className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 3 ? 'bg-blue-500 text-white' : ''}`}>
                                        <RequestQuoteOutlinedIcon className="mr-2" />
                                        {t('pagamento')}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(4);
                                            setIsOpen(false);
                                        }}
                                        href="#"
                                        className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 4 ? 'bg-blue-500 text-white' : ''}`}>
                                        <EventAvailableOutlinedIcon className="mr-2" />
                                        {t('garantia')}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(5);
                                            setIsOpen(false);
                                        }}
                                        href="#"
                                        className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 5 ? 'bg-blue-500 text-white' : ''}`}>
                                        <BuildCircleOutlinedIcon className="mr-2" />
                                        {t('manutencao')}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(6);
                                            setIsOpen(false);
                                        }}
                                        href="#"
                                        className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 6 ? 'bg-blue-500 text-white' : ''}`}>
                                        <ChangeCircleOutlinedIcon className="mr-2" />
                                        {t('retoma')}
                                    </a>
                                </li>

                                {propostaSelecionada && (
                                    <>
                                        <li>
                                            <a
                                                href="#"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    setOpenTab(7);
                                                    setIsOpen(false);
                                                }}
                                                className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 7 ? 'bg-blue-500 text-white' : ''}`}>
                                                <BarChartRoundedIcon className="mr-2" />
                                                {t('status')}
                                            </a>
                                        </li>
                                    </>
                                )}
                                {propostaSelecionada && (
                                    <>
                                        <li>
                                            <a
                                                href="#"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    setOpenTab(8);
                                                    setIsOpen(false);
                                                }}
                                                className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${openTab === 8 ? 'bg-blue-500 text-white' : ''}`}>
                                                <FindInPageOutlinedIcon className="mr-2" />
                                                {t('PA')}
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    )}

                    <DrawerFilter
                        setGuardar={setGuardar}
                        setEnviarEmailProposta={setEnviarEmailProposta}
                        imprimirProposta={imprimirProposta}
                        setImprimirProposta={setImprimirProposta}
                        setGerarRevisaoProposta={setGerarRevisaoProposta}
                        editarProposta={editarProposta}
                        setEditarProposta={setEditarProposta}
                        showForm={showForm}
                        setShowForm={setShowForm}
                        // setShowForm={estado => {
                        //     setShowForm(estado);
                        //     setPropostaSelecionada(null);
                        //     setEditarProposta(false);
                        // }}
                        setOnChangeForm={setOnChangeForm}
                        onChangeForm={onChangeForm}
                        setOpenTab={setOpenTab}
                        setPropostaSelecionada={setPropostaSelecionada}
                        propostaSelecionada={propostaSelecionada}
                        filtroTipo={filtroTipo}
                        setFiltroTipo={setFiltroTipo}
                        filtroDt={filtroDt}
                        setFiltroDt={setFiltroDt}
                        filtroCliente={filtroCliente}
                        setFiltroCliente={setFiltroCliente}
                        filtroEstado={filtroEstado}
                        filtroEncomenda={filtroEncomenda}
                        setFiltroEncomenda={setFiltroEncomenda}
                        setFiltroEstado={setFiltroEstado}
                        filtroRepresentantes={filtroRepresentantes}
                        setFiltroRepresentantes={setFiltroRepresentantes}
                        filtroLinhas={filtroLinhas}
                        setFiltroLinhas={setFiltroLinhas}
                        estados={estados}
                        tipos={tipos}
                        representantes={representantes}
                        proposta={propostaSelecionada}
                        openTab={openTab}
                        // filtro status
                        filtroDtStatus={filtroDtStatus}
                        setFiltroDtStatus={setFiltroDtStatus}
                        filtroUtilizador={filtroUtilizador}
                        setFiltroUtilizador={setFiltroUtilizador}
                        filtroAcao={filtroAcao}
                        setFiltroAcao={setFiltroAcao}
                        filtroDestinatarios={filtroDestinatarios}
                        setFiltroDestinatarios={setFiltroDestinatarios}
                        filtroEmail={filtroEmail}
                        setFiltroEmail={setFiltroEmail}
                    />
                </div>
            ) : (
                <div className="border-b mb-5 border-gray-200 dark:border-gray-600">
                    <div
                        className="flex flex-wrap items-center justify-between -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
                        role="tablist"
                        id="myTab"
                        data-tabs-toggle="#myTabContent">
                        <div className="flex space-x-2">
                            {' '}
                            {showForm && (
                                <div>
                                    {/* Separador de "Dados base" */}
                                    <button
                                        aria-controls="agenda"
                                        id="agenda-tab"
                                        type="button"
                                        data-toggle="tab"
                                        href="#link1"
                                        role="tablist"
                                        aria-current="page"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 1
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(1);
                                        }}>
                                        <TextSnippetOutlinedIcon className="mr-2" />
                                        {t('dadosBase')}
                                    </button>

                                    {/* Separador de "Geral" */}
                                    <button
                                        aria-controls="calendario"
                                        id="calendario-tab"
                                        data-toggle="tab"
                                        href="#link2"
                                        role="tablist"
                                        type="button"
                                        // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 2
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(2);
                                        }}>
                                        <SummarizeOutlinedIcon className="mr-2" />
                                        {t('geral')}
                                    </button>

                                    {/* Separador de "Pagamento" */}
                                    <button
                                        aria-controls="calendario"
                                        id="calendario-tab"
                                        data-toggle="tab"
                                        href="#link2"
                                        role="tablist"
                                        type="button"
                                        // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 3
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(3);
                                        }}>
                                        <RequestQuoteOutlinedIcon className="mr-2" />
                                        {t('pagamento')}
                                    </button>

                                    {/* Separador de "Garantia" */}
                                    <button
                                        aria-controls="calendario"
                                        id="calendario-tab"
                                        data-toggle="tab"
                                        href="#link2"
                                        role="tablist"
                                        type="button"
                                        // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 4
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(4);
                                        }}>
                                        <EventAvailableOutlinedIcon className="mr-2" />
                                        {t('garantia')}
                                    </button>

                                    {/* Separador de "Manutenção" */}
                                    <button
                                        aria-controls="calendario"
                                        id="calendario-tab"
                                        data-toggle="tab"
                                        href="#link2"
                                        role="tablist"
                                        type="button"
                                        // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 5
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(5);
                                        }}>
                                        <BuildCircleOutlinedIcon className="mr-2" />
                                        {t('manutencao')}
                                    </button>
                                    <button
                                        aria-controls="agenda"
                                        id="agenda-tab"
                                        type="button"
                                        data-toggle="tab"
                                        href="#link1"
                                        role="tablist"
                                        aria-current="page"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 9
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(9);
                                        }}>
                                        <FileOpenOutlinedIcon className="mr-2" />
                                        {t('contratoFinanceiro')}
                                    </button>
                                    {/* Separador de "Retoma" */}
                                    <button
                                        aria-controls="calendario"
                                        id="calendario-tab"
                                        data-toggle="tab"
                                        href="#link2"
                                        role="tablist"
                                        type="button"
                                        // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                        className={
                                            'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                            (openTab === 6
                                                ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                        }
                                        onClick={e => {
                                            e.preventDefault();
                                            setOpenTab(6);
                                        }}>
                                        <ChangeCircleOutlinedIcon className="mr-2" />
                                        {t('retoma')}
                                    </button>
                                   
                                    {/* Separador de "Status" */}
                                    {propostaSelecionada && (
                                        <button
                                            aria-controls="calendario"
                                            id="calendario-tab"
                                            data-toggle="tab"
                                            href="#link2"
                                            role="tablist"
                                            type="button"
                                            // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                            className={
                                                'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                                (openTab === 7
                                                    ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                    : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                            }
                                            onClick={e => {
                                                e.preventDefault();
                                                setOpenTab(7);
                                            }}>
                                            <BarChartRoundedIcon className="mr-2" />
                                            {t('status')}
                                        </button>
                                    )}
                                    {propostaSelecionada && (
                                        <button
                                            aria-controls="calendario"
                                            id="calendario-tab"
                                            data-toggle="tab"
                                            href="#link2"
                                            role="tablist"
                                            type="button"
                                            // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                            className={
                                                'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                                (openTab === 8
                                                    ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                                    : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                            }
                                            onClick={e => {
                                                e.preventDefault();
                                                setOpenTab(8);
                                            }}>
                                            <FindInPageOutlinedIcon className="mr-2" />
                                            {t('PA')}
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>

                        <DrawerFilter
                            encomendas={encomendas}
                            setGuardar={setGuardar}
                            filtroEncomenda={filtroEncomenda}
                            setFiltroEncomenda={setFiltroEncomenda}
                            setEnviarEmailProposta={setEnviarEmailProposta}
                            filtroDescNegocio={filtroDescNegocio}
                            setFiltroDesNegocio={setFiltroDesNegocio}
                            imprimirProposta={imprimirProposta}
                            setImprimirProposta={setImprimirProposta}
                            setGerarRevisaoProposta={setGerarRevisaoProposta}
                            editarProposta={editarProposta}
                            setEditarProposta={setEditarProposta}
                            showForm={showForm}
                            setShowForm={setShowForm}
                            // setShowForm={estado => {
                            //     setShowForm(estado);
                            //     setPropostaSelecionada(null);
                            //     setEditarProposta(false);
                            // }}
                            setOnChangeForm={setOnChangeForm}
                            onChangeForm={onChangeForm}
                            setOpenTab={setOpenTab}
                            setPropostaSelecionada={setPropostaSelecionada}
                            propostaSelecionada={propostaSelecionada}
                            filtroTipo={filtroTipo}
                            setFiltroTipo={setFiltroTipo}
                            filtroDt={filtroDt}
                            setFiltroDt={setFiltroDt}
                            filtroCliente={filtroCliente}
                            setFiltroCliente={setFiltroCliente}
                            filtroEstado={filtroEstado}
                            setFiltroEstado={setFiltroEstado}
                            filtroRepresentantes={filtroRepresentantes}
                            setFiltroRepresentantes={setFiltroRepresentantes}
                            filtroLinhas={filtroLinhas}
                            setFiltroLinhas={setFiltroLinhas}
                            estados={estados}
                            tipos={tipos}
                            representantes={representantes}
                            proposta={propostaSelecionada}
                            openTab={openTab}
                            // filtro status
                            filtroDtStatus={filtroDtStatus}
                            setFiltroDtStatus={setFiltroDtStatus}
                            filtroUtilizador={filtroUtilizador}
                            setFiltroUtilizador={setFiltroUtilizador}
                            filtroAcao={filtroAcao}
                            setFiltroAcao={setFiltroAcao}
                            filtroDestinatarios={filtroDestinatarios}
                            setFiltroDestinatarios={setFiltroDestinatarios}
                            filtroEmail={filtroEmail}
                            setFiltroEmail={setFiltroEmail}
                        />
                    </div>
                </div>
            )}

            <div id="myTabContent">
                {!showForm && (
                    <Table
                        onRowClick={handleRowClick}
                        filtroCodigo={filtroCodigo}
                        setFiltroCodigo={setFiltroCodigo}
                        filtroDescNegocio={filtroDescNegocio}
                        setFiltroDesNegocio={setFiltroDesNegocio}
                        filtroTipo={filtroTipo}
                        setFiltroTipo={setFiltroTipo}
                        filtroDt={filtroDt}
                        setFiltroDt={setFiltroDt}
                        filtroCliente={filtroCliente}
                        setFiltroCliente={setFiltroCliente}
                        filtroEstado={filtroEstado}
                        setFiltroEstado={setFiltroEstado}
                        filtroRepresentantes={filtroRepresentantes}
                        setFiltroRepresentantes={setFiltroRepresentantes}
                        filtroLinhas={filtroLinhas}
                        setFiltroLinhas={setFiltroLinhas}
                        estados={estados}
                        tipos={tipos}
                        representantes={representantes}
                        filtroEncomenda={filtroEncomenda}
                        setFiltroEncomenda={setFiltroEncomenda}
                    />
                )}
                {showForm && (
                    <NovaProposta
                        imprimirProposta={imprimirProposta}
                        setImprimirProposta={setImprimirProposta}
                        guardar={guardar}
                        onChangeForm={onChangeForm}
                        enviarEmailProposta={enviarEmailProposta}
                        setEnviarEmailProposta={setEnviarEmailProposta}
                        gerarRevisaoProposta={gerarRevisaoProposta}
                        setGerarRevisaoProposta={setGerarRevisaoProposta}
                        setShowForm={setShowForm}
                        setEditarProposta={setEditarProposta}
                        editarProposta={editarProposta}
                        setGuardar={setGuardar}
                        setOnChangeForm={setOnChangeForm}
                        proposta={propostaSelecionada}
                        // historyData={history.location.state}
                        idNegocio={idNegocio}
                        openTab={openTab}
                        setOpenTab={setOpenTab}
                        // filtro status
                        filtroDtStatus={filtroDtStatus}
                        setFiltroDtStatus={setFiltroDtStatus}
                        filtroUtilizador={filtroUtilizador}
                        setFiltroUtilizador={setFiltroUtilizador}
                        filtroAcao={filtroAcao}
                        setFiltroAcao={setFiltroAcao}
                        filtroDestinatarios={filtroDestinatarios}
                        setFiltroDestinatarios={setFiltroDestinatarios}
                        filtroEmail={filtroEmail}
                        setFiltroEmail={setFiltroEmail}
                    />
                )}
            </div>
        </>
    );
}

export default Propostas;
